import request from '@/utils/request'
import axios from 'axios'

const url = '/';
// const url = window.location.protocol+'//ser.ddh.ez6.com.cn/';   //正式

//通用上传文件
export function upload (data) {
  var fd = new FormData();
  for(var key in data){
    console.log(key)
    fd.append(key,data[key]);
  }
  console.log(fd.get('file'));
  return request({
    url: url+'file/qiniu/upload',
    method: 'post',
    data: fd,
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

//获取手机短信验证码
export function sms (data) {
  return request({
    url: url+'auth/ali/sms',
    method: 'get',
    params: data,
  })
}

//用户登陆
export function login (data) {
  return request({
    url: url+'yhcms/user/login',
    method: 'get',
    params: data,
  })
}

//登录用户详情
export function loginUserDetail (data) {
  return request({
    url: url+'yhcms/business/loginUserDetail',
    method: 'post',
    params: data,
  })
}

//文章新增
export function articleAdd (data) {
  return request({
    url: url+'business/articleAdd',
    method: 'post',
    data: data,
  })
}

//文章详情
export function articleDetail (data) {
  return request({
    url: url+'business/articleDetail',
    method: 'post',
    data: data,
  })
}

//文章分页
export function articlePage (data) {
  return request({
    url: url+'yhcms/business/articlePage',
    method: 'post',
    data: data,
  })
}

//文章下的广告列表
export function articleAdvertPage () {
  return request({
    url: url+'business/articleAdvertPage',
    method: 'post',
  })
}

//领域列表
export function domainPage (data) {
  return request({
    url: url+'business/domainPage',
    method: 'post',
    data: data,
  })
}

//修改用户基本信息
export function loginUserEdit (data) {
  return request({
    url: url+'yhcms/business/loginUserEdit',
    method: 'post',
    data: data,
  })
}

//获取数据字典 [文章类型:CMS_ARTICLE_TYPE]  [用户类型:USER_TYPE]
export function getByType (TYPE) {
  return request({
    url: url+'sys/dict/getByType',
    method: 'get',
    params: {type: TYPE}
  })
}

//首页banner列表
export function bannerPage (data) {
  return request({
    url: url+'business/bannerPage',
    method: 'post',
    data: data
  })
}

//常见问题【分页】
export function kbPage (data) {
  return request({
    url: url+'business/kbPage',
    method: 'post',
    data: data,
  })
}
//常见问题【详情】
export function kbDetail (data) {
  return request({
    url: url+'business/kbDetail',
    method: 'post',
    data: data,
  })
}

//反馈建议
export function feedbackAdd (data) {
  return request({
    url: url+'business/feedbackAdd',
    method: 'post',
    data: data,
  })
}

//修改手机号
export function updateMobile (data) {
  return request({
    url: url+'yhcms/user/updateMobile',
    method: 'get',
    params: data,
  })
}

//添加文章评论
export function articleReplyAdd (data) {
  return request({
    url: url+'business/articleReplyAdd',
    method: 'post',
    data: data,
  })
}
//文章评论【分页】
export function articleReplyPage (data) {
  return request({
    url: url+'business/articleReplyPage',
    method: 'post',
    data: data,
  })
}

//回复新增评论
export function articleReplyChildAdd (data) {
  return request({
    url: url+'business/articleReplyChildAdd',
    method: 'post',
    data: data,
  })
}
//回复评论【分页】
export function articleReplyChildPage (data) {
  return request({
    url: url+'business/articleReplyChildPage',
    method: 'post',
    data: data,
  })
}

//文章点赞
export function articleThumbupAdd (data) {
  return request({
    url: url+'yhcms/business/articleThumbupAdd',
    method: 'post',
    data: data,
  })
}

//文章取消点赞
export function articleThumbupDelete (data) {
  return request({
    url: url+'yhcms/business/articleThumbupDelete',
    method: 'post',
    data: data,
  })
}

//文章收藏
export function articleFav (data) {
  return request({
    url: url+'yhcms/business/articleFav',
    method: 'post',
    data: data,
  })
}

//文章取消收藏
export function articleUnFav (data) {
  return request({
    url: url+'yhcms/business/articleUnFav',
    method: 'post',
    data: data,
  })
}

//评论点赞
export function articleReplyThumbupAdd (data) {
  return request({
    url: url+'yhcms/business/articleReplyThumbupAdd',
    method: 'post',
    data: data,
  })
}

//评论取消点赞
export function articleReplyThumbupDelete (data) {
  return request({
    url: url+'yhcms/business/articleReplyThumbupDelete',
    method: 'post',
    data: data,
  })
}

//关注的医生 分页
export function userFavPage (data) {
  return request({
    url: url+'yhcms/business/userFavPage',
    method: 'post',
    data: data,
  })
}

//关注医生
export function userFav (data) {
  return request({
    url: url+'yhcms/business/userFav',
    method: 'post',
    data: data,
  })
}

//取消关注医生
export function userUnFav (data) {
  return request({
    url: url+'yhcms/business/userUnFav',
    method: 'post',
    data: data,
  })
}

//专家列表 分页
export function userPage (data) {
  return request({
    url: url+'yhcms/business/userPage',
    method: 'post',
    data: data,
  })
}

//专家详情
export function userDetail (data) {
  return request({
    url: url+'business/userDetail',
    method: 'post',
    data: data,
  })
}

//评论回复点赞
export function articleReplyChildThumbupAdd (data) {
  return request({
    url: url+'yhcms/business/articleReplyChildThumbupAdd',
    method: 'post',
    data: data,
  })
}

//评论回复取消点赞
export function articleReplyChildThumbupDelete(data){
  return request({
    url: url+'yhcms/business/articleReplyChildThumbupDelete',
    method: 'post',
    data: data,
  })
}

//获取数据字典【多选】
export function getByTypes(data){
  return request({
    url: url+'sys/dict/getByTypes',
    method: 'post',
    data: data,
  })
}

//登陆用户发布的文章分页
export function myArticlePage(data){
  return request({
    url: url+'yhcms/business/myArticlePage',
    method: 'post',
    data: data,
  })
}

//登陆用户文章的评论分页
export function myArticleReplyPage(data){
  return request({
    url: url+'yhcms/business/myArticleReplyPage',
    method: 'post',
    data: data,
  })
}

//谁关注了登陆用户分页
export function myFansPage(data){
  return request({
    url: url+'yhcms/business/myFansPage',
    method: 'post',
    data: data,
  })
}

//谁给登陆用户发布的文章点赞 分页
export function myThumbupPage(data){
  return request({
    url: url+'yhcms/business/myThumbupPage',
    method: 'post',
    data: data,
  })
}

//给文章增加分享数
export function articleShareAdd(data){
  return request({
    url: url+'yhcms/business/articleShareAdd',
    method: 'post',
    data: data,
  })
}
//评论详情
export function articleReplyDetail(data){
  return request({
    url: url+'business/articleReplyDetail',
    method: 'post',
    data: data,
  })
}

//获取领域下的专家
export function domainConfigPage(data){
  return request({
    url: url+'business/domainConfigPage',
    method: 'post',
    data: data,
  })
}

// 获取分享参数
export function share_config(params) {
  return request({
    url: url+'yhcms/message/share/GetWeChatJs',
    method: 'get',
    params: params
  })
}

//获取专题列表
export function topicList(){
  return request({
    url: url+'yhcms/business/topicList',
    method: 'post',
  })
}

//获取专题详情
export function topicDetail(data){
  return request({
    url: url+'yhcms/business/topicDetail',
    method: 'post',
    data: data,
  })
}


//获取专题文章列表
export function articleTopicPage(data){
  return request({
    url: url+'business/articleTopicPage',
    method: 'post',
    data: data,
  })
}


// WEBPACK FOOTER //
// ./src/utils/api.js